import { render, staticRenderFns } from "./DataroleDetail.vue?vue&type=template&id=51c05599&scoped=true"
import script from "./DataroleDetail.vue?vue&type=script&lang=js"
export * from "./DataroleDetail.vue?vue&type=script&lang=js"
import style0 from "./DataroleDetail.vue?vue&type=style&index=0&id=51c05599&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c05599",
  null
  
)

export default component.exports